import script from "./Groups.vue?vue&type=script&setup=true&lang=js"
export * from "./Groups.vue?vue&type=script&setup=true&lang=js"

import "./Groups.vue?vue&type=style&index=0&id=b4bd0434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4bd0434"]])

export default __exports__